export default __webpack_public_path__ + "static/media/about-us-3.d6adf270.jpg";